// @ts-check
import React, { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { login } from '../redux/actions/login-actions';
import { useHistory } from 'react-router-dom';

import { Formik } from 'formik';
import * as Yup from 'yup';

import { makeStyles } from '@material-ui/core/styles';
import { TextField, Button, Grid, CircularProgress } from '@material-ui/core';

import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';

import { resetApp } from '../../../../core/redux/actions/reset-app';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    }
  },
  margin: {
    margin: theme.spacing(1)
  },
  logo: {
    height: '3rem'
  },
  logoContainer: {
    textAlign: 'center',
    margin: theme.spacing(3),
    marginTop: theme.spacing(10)
  },
  formButtons: {
    marginTop: theme.spacing(4)
  },
  errorText: {
    color: '#f44336',
    textAlign: 'center',
    display: 'block',
    margin: theme.spacing(3)
  }
}));

export function Login(props) {
  const classes = useStyles();
  const { error, loading } = useSelector((state) => state.login);

  // const onSave = (e) => {
  //   e.preventDefault();
  //   setLoading(true);

  //   setTimeout(() => {
  //     setLoading(false);
  //     history.push('/');
  //   }, 1000);
  // };

  const {
    values,
    // values: { name, email, password, confirmPassword },
    errors,
    touched,
    handleSubmit,
    handleChange,
    handleBlur
    // isValid,
    // setFieldTouched
  } = props;
  // console.table(props);

  /**
   * @param {string} name
   */
  const formikProps = (name, initialValue = '') => ({
    name: name,
    value: typeof values[name] !== 'undefined' ? values[name] : initialValue,
    onChange: handleChange,
    onBlur: handleBlur,
    error: touched[name] && Boolean(errors[name]),
    helperText: touched[name] ? errors[name] : ''
  });

  return (
    <form className={classes.root} noValidate autoComplete="off" onSubmit={handleSubmit}>
      <div className={classes.logoContainer}>
        <img className={classes.logo} src="http://cowabunga.co.za/static/img/logo.svg" alt="logo" />
      </div>
      <TextField
        {...formikProps('email')}
        id="outlined-full-width"
        label="Email"
        type="text"
        variant="outlined"
        fullWidth={true}
      />

      <TextField
        {...formikProps('password')}
        id="outlined-password-input"
        label="Password"
        type="password"
        autoComplete="current-password"
        variant="outlined"
        fullWidth={true}
      />

      <div className={classes.formButtons}>
        {!loading && (
          <Button
            type="submit"
            variant="contained"
            size="large"
            color="primary"
            fullWidth={true}
            // disabled={!isValid}
          >
            Sign In
          </Button>
        )}

        {loading && (
          <Button variant="contained" size="large" color="primary" fullWidth={true}>
            <CircularProgress color="inherit" size={26} />
          </Button>
        )}

        {error && (
          <div>
            <span className={classes.errorText}>{error.message}</span>
          </div>
        )}
      </div>
    </form>
  );
}

const validationSchema = Yup.object({
  email: Yup.string('Enter your email').email('Enter a valid email').required('Email is required'),
  password: Yup.string('')
    .min(8, 'Password must contain atleast 8 characters')
    .required('Enter your password')
});

function FormValidation() {
  const history = useHistory();
  const dispatch = useDispatch();

  const values = { email: '', password: '' };

  const submit = (data, actions) => {
    dispatch(login(data.email, data.password, { history }));
    // actions.resetForm();
  };

  return (
    <Formik initialValues={values} validationSchema={validationSchema} onSubmit={submit}>
      {(props) => <Login {...props} />}
    </Formik>
  );
}

export function LoginPage() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(resetApp());
  }, [dispatch]);

  return (
    <React.Fragment>
      <CssBaseline />
      <Container>
        <Grid container spacing={3} justify="center">
          <Grid item sm={7} md={5}>
            <FormValidation />
          </Grid>
        </Grid>
      </Container>
    </React.Fragment>
  );
}
